export const workEnvironment = {
  junior: {
    macos: [
      { step: 'Install Figma', command: 'brew install --cask figma' },
      { step: 'Install Sketch', command: 'brew install --cask sketch' },
      { step: 'Install Adobe Creative Cloud', command: 'brew install --cask adobe-creative-cloud' },
      { step: 'Install Slack', command: 'brew install --cask slack' },
      { step: 'Install Zoom', command: 'brew install --cask zoom' },
      { step: 'Install Notion', command: 'brew install --cask notion' },
      { step: 'Install Chrome', command: 'brew install --cask google-chrome' }
    ],
    windows: [
      { step: 'Install Figma', command: 'choco install figma' },
      { step: 'Install Adobe Creative Cloud', command: 'choco install adobecreativecloud' },
      { step: 'Install Slack', command: 'choco install slack' },
      { step: 'Install Zoom', command: 'choco install zoom' },
      { step: 'Install Microsoft Office', command: 'choco install office365business' },
      { step: 'Install Teams', command: 'choco install microsoft-teams' },
      { step: 'Install Chrome', command: 'choco install googlechrome' }
    ],
    linux: [
      { step: 'Install Chrome', command: 'wget -q -O - https://dl.google.com/linux/linux_signing_key.pub | sudo apt-key add - && echo "deb [arch=amd64] http://dl.google.com/linux/chrome/deb/ stable main" | sudo tee /etc/apt/sources.list.d/google-chrome.list && sudo apt update && sudo apt install google-chrome-stable' },
      { step: 'Install Slack', command: 'sudo snap install slack --classic' },
      { step: 'Install GIMP', command: 'sudo apt install gimp' },
      { step: 'Install Inkscape', command: 'sudo apt install inkscape' },
      { step: 'Install Blender', command: 'sudo snap install blender --classic' },
      { step: 'Install VS Code', command: 'sudo snap install code --classic' }
    ]
  },
  mid: {
    macos: [
      { step: 'Install Framer', command: 'brew install --cask framer' },
      { step: 'Install Principle', command: 'brew install --cask principle' },
      { step: 'Install Zeplin', command: 'brew install --cask zeplin' },
      { step: 'Install Abstract', command: 'Web-based version control platform' },
      { step: 'Install Miro', command: 'brew install --cask miro' },
      { step: 'Install Loom', command: 'brew install --cask loom' }
    ],
    windows: [
      { step: 'Install Adobe XD', command: 'choco install adobexd' },
      { step: 'Install Figma Desktop', command: 'choco install figma' },
      { step: 'Install Miro', command: 'choco install miro' },
      { step: 'Install Loom', command: 'choco install loom' },
      { step: 'Install Power BI Desktop', command: 'choco install powerbi' },
      { step: 'Install Visio', command: 'choco install visio' }
    ],
    linux: [
      { step: 'Install Figma Web App', command: 'Create desktop shortcut for Figma web application' },
      { step: 'Install Penpot', command: 'Web-based open source design tool' },
      { step: 'Install Krita', command: 'sudo apt install krita' },
      { step: 'Install Gravit Designer', command: 'sudo snap install gravit-designer' },
      { step: 'Install draw.io desktop', command: 'sudo snap install drawio' }
    ]
  },
  senior: {
    macos: [
      { step: 'Install Design Operations Suite', command: 'Configure enterprise design management tools' },
      { step: 'Install Advanced Prototyping Tools', command: 'Set up advanced prototyping and animation platforms' },
      { step: 'Install Design Analytics Tools', command: 'Configure design performance and analytics platforms' },
      { step: 'Install Design System Management', command: 'Set up design system and component library tools' }
    ],
    windows: [
      { step: 'Install Advanced Power Platform', command: 'Configure Power Platform Premium for design automation' },
      { step: 'Install Azure Design Services', command: 'Set up Azure-based design and collaboration tools' },
      { step: 'Install Advanced Office Suite', command: 'Configure advanced Office features for design collaboration' },
      { step: 'Install Enterprise Analytics', command: 'Set up enterprise design analytics and reporting tools' }
    ],
    linux: [
      { step: 'Install Design Infrastructure Stack', command: 'docker-compose up -d for design system infrastructure' },
      { step: 'Install Advanced Design Tools', command: 'Set up advanced open source design and prototyping tools' },
      { step: 'Install Design Automation Pipeline', command: 'Configure automated design workflow and asset generation' },
      { step: 'Install Collaboration Infrastructure', command: 'Set up design collaboration and review infrastructure' }
    ]
  }
};
